<template>
  <div>
    <v-row>
      <v-col cols="12">
        <div class="d-flex align-center justify-space-between mb-4">
          <p class="text-2xl mb-0">
            Listas de Automação
          </p>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card flat>
          <v-card-text class="pa-3">
            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="4"
              >
                <v-text-field
                  v-model="filterName"
                  :append-icon="icons.mdiMagnify"
                  label="Nome"
                  hide-details
                  outlined
                  dense
                  @click:append="filterLists"
                  @keypress.enter="filterLists"
                />
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider />
          <v-card-actions class="pa-3">
            <v-btn
              color="primary"
              class="pl-4"
              @click="filterLists"
            >
              Pesquisar
              <v-icon
                right
                dark
              >
                {{ icons.mdiMagnify }}
              </v-icon>
            </v-btn>
            <v-btn
              color="error"
              outlined
              @click="clearFilter"
            >
              Limpar filtro
            </v-btn>

            <v-spacer />

            <v-btn
              color="primary"
              class="pl-4"
              outlined
              @click="openFormToCreate"
            >
              Adicionar nova lista
              <v-icon
                right
                dark
              >
                {{ icons.mdiTablePlus }}
              </v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="lists"
          :items-per-page="10"
          item-key="id"
          disable-sort
          dense
        >
          <!-- eslint-disable vue/valid-v-for -->
          <template
            v-for="col in headersWithFilter"
            v-slot:[`header.${col}`]="{ header }"
          >
            {{ header.text }}

            <v-btn
              color="white"
              icon
              @click="dialogFilter = true"
            >
              <v-icon small>
                {{ icons.mdiFilterMenu }}
              </v-icon>
            </v-btn>
          </template>
          <!-- eslint-disable vue/valid-v-for -->

          <template #[`item.action`]="{ item }">
            <!-- <v-btn
              color="info"
              title="Visualizar"
              icon
              @click="openListDetail(item)"
            >
              <v-icon>{{ icons.mdiEye }}</v-icon>
            </v-btn> -->
            <v-btn
              color="info"
              title="Editar"
              icon
              @click="openFormToEdit(item)"
            >
              <v-icon>{{ icons.mdiFileEdit }}</v-icon>
            </v-btn>
            <v-btn
              color="error"
              title="Excluir"
              icon
              @click="confirmDelete(item)"
            >
              <v-icon>{{ icons.mdiDelete }}</v-icon>
            </v-btn>
          </template>

          <template #[`item.name`]="{ item }">
            <div
              class="text-truncate"
              style="max-width: 200px;"
            >
              {{ item.name }}
            </div>
          </template>

          <template #[`item.tags`]="{ item }">
            <div class="d-flex flex-wrap">
              <v-chip
                v-for="(tag, index) in (item.tags || []).slice(0, 3)"
                :key="index"
                small
                class="ma-1"
                color="info"
              >
                {{ tag }}
              </v-chip>
              <span
                v-if="(item.tags || []).length > 3"
                class="text-xs text--secondary ma-1"
              >
                +{{ (item.tags || []).length - 3 }} mais
              </span>
              <span
                v-if="!item.tags || item.tags.length === 0"
                class="text-xs text--secondary"
              >
                Sem tags
              </span>
            </div>
          </template>

          <template #[`item.status`]="{ item }">
            <v-chip
              :color="resolveStatus(item.status).color"
              small
              label
            >
              <span class="white--text">
                {{ resolveStatus(item.status).label }}
              </span>
            </v-chip>
          </template>

          <template #[`item.createdAt`]="{ item }">
            <div class="d-flex flex-column my-1">
              <span>
                <v-icon size="18">
                  {{ icons.mdiCalendar }}
                </v-icon>
                {{ $day(item.createdAt).format('DD/MM/YYYY') }}
              </span>
              <span>
                <v-icon size="18">
                  {{ icons.mdiClock }}
                </v-icon>
                {{ $day(item.createdAt).format('HH:mm') }}
              </span>
            </div>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <filter-list-automation
      :status="dialogFilter"
      @filter="filterLists"
      @close="dialogFilter = false"
    />

    <v-dialog
      v-model="dialogCreateList"
      max-width="1000"
      persistent
    >
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          {{ isEditMode ? 'Editar lista' : 'Nova lista' }}
          <v-spacer />
          <v-btn
            text
            x-small
            fab
            @click="closeCreateListDialog"
          >
            <v-icon color="error">
              {{ icons.mdiClose }}
            </v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pt-6">
          <v-row>
            <v-col
              cols="12"
              md="6"
              sm="12"
            >
              <v-text-field
                v-model="createListForm.name"
                label="Nome"
                hide-details
                outlined
                dense
                clearable
              />
            </v-col>

            <v-col
              cols="12"
              md="6"
              sm="12"
            >
              <v-combobox
                v-model="createListForm.tags"
                label="Tags"
                multiple
                chips
                small-chips
                clearable
                hide-details
                outlined
                dense
              />
            </v-col>

            <!-- <v-col cols="12">
              <v-switch
                v-model="createListForm.isDynamic"
                inset
                hide-details
                label="Lista dinâmica?"
              />
            </v-col> -->
          </v-row>

          <!-- Tabela de Leads - Apenas no modo edição -->
          <v-row v-if="isEditMode">
            <v-col cols="12">
              <div class="text-h6 mb-3">
                Leads (QTD: {{ leads.length }})
              </div>
              <v-data-table
                :headers="leadsHeaders"
                :items="leads"
                :items-per-page="10"
                item-key="id"
                disable-sort
                dense
                class="elevation-1"
                no-data-text="Nenhum lead cadastrado"
              >
                <template #[`item.action`]="{ item }">
                  <v-btn
                    color="info"
                    title="Editar"
                    icon
                    small
                    @click="openLeadForm(item)"
                  >
                    <v-icon small>{{ icons.mdiFileEdit }}</v-icon>
                  </v-btn>
                  <v-btn
                    color="error"
                    title="Excluir"
                    icon
                    small
                    @click="confirmDeleteLead(item)"
                  >
                    <v-icon small>{{ icons.mdiDelete }}</v-icon>
                  </v-btn>
                </template>

                <template #[`item.createdAt`]="{ item }">
                  <div v-if="item.createdAt">
                    <div class="d-flex flex-column my-1">
                      <span>
                        <v-icon size="18">
                          {{ icons.mdiCalendar }}
                        </v-icon>
                        {{ $day(item.createdAt).format('DD/MM/YYYY') }}
                      </span>
                      <span>
                        <v-icon size="18">
                          {{ icons.mdiClock }}
                        </v-icon>
                        {{ $day(item.createdAt).format('HH:mm') }}
                      </span>
                    </div>
                  </div>
                  <span v-else>-</span>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>

        <!-- Modal de edição/exclusão de lead -->
        <v-dialog
          v-model="dialogLead"
          max-width="900"
          persistent
        >
          <v-card>
            <v-card-title class="text-h5 grey lighten-2">
              Editar lead
              <v-spacer />
              <v-btn
                text
                x-small
                fab
                @click="closeLeadDialog"
              >
                <v-icon color="error">
                  {{ icons.mdiClose }}
                </v-icon>
              </v-btn>
            </v-card-title>

            <v-card-text class="pt-6">
              <v-row>
                <v-col cols="12" md="6" sm="12">
                  <v-text-field
                    v-model="leadForm.nome"
                    label="Nome"
                    hide-details
                    outlined
                    dense
                  />
                </v-col>

                <v-col cols="12" md="6" sm="12">
                  <v-text-field
                    v-model="leadForm.telefone"
                    label="Telefone"
                    hide-details
                    outlined
                    dense
                  />
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="leadForm.email"
                    label="E-mail"
                    hide-details
                    outlined
                    dense
                    clearable
                  />
                </v-col>

                <v-col cols="12">
                  <v-textarea
                    v-model="leadForm.variablesJson"
                    label="Variáveis (JSON) - ex: {&quot;NOME&quot;:&quot;Pedro&quot;,&quot;LINK&quot;:&quot;www...&quot;}"
                    hide-details
                    outlined
                    auto-grow
                    dense
                  />
                </v-col>
              </v-row>
            </v-card-text>

            <v-divider />

            <v-card-actions>
              <v-spacer />
              <v-btn
                color="error"
                outlined
                @click="closeLeadDialog"
              >
                Cancelar
              </v-btn>
              <v-btn
                color="info"
                :disabled="!leadForm.nome || !leadForm.telefone"
                @click="submitLeadUpdate"
              >
                Salvar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="error"
            outlined
            @click="closeCreateListDialog"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="info"
            :disabled="!createListForm.name"
            @click="submitCreateList"
          >
            {{ isEditMode ? 'Atualizar' : 'Salvar' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { ref } from '@vue/composition-api'
import {
  mdiCalendar,
  mdiClock,
  mdiEye,
  mdiFilterMenu,
  mdiFileEdit,
  mdiClose,
  mdiMagnify,
  mdiTablePlus,
  mdiDelete,
} from '@mdi/js'

export default {
  name: 'ServiceListAutomation',

  components: {
    FilterListAutomation: () => import('./filter.vue'),
  },

  setup() {
    const dialogFilter = ref(false)
    const filterName = ref(null)
    const dialogCreateList = ref(false)
    const isEditMode = ref(false)
    const editingListId = ref(null)
    const createListForm = ref({
      name: null,
      tags: [],
      isDynamic: false,
    })
    const leads = ref([])
    const dialogLead = ref(false)
    const editingLeadId = ref(null)
    const leadForm = ref({
      nome: null,
      telefone: null,
      email: null,
      variablesJson: '{}',
    })

    const headers = [
      { text: 'Ações', value: 'action', align: 'center' },
      { text: 'ID', value: 'id', align: 'center' },
      { text: 'Nome', value: 'name' },
      { text: 'Tags', value: 'tags' },
      { text: 'Status', value: 'status' },
      { text: 'Data de Criação', value: 'createdAt' },
    ]

    const headersWithFilter = [
      'id',
      'name',
      'status',
      'createdAt',
    ]

    const leadsHeaders = [
      { text: 'Ações', value: 'action', align: 'center', width: '120px' },
      { text: 'Nome', value: 'name' },
      { text: 'Telefone', value: 'phone' },
      { text: 'E-mail', value: 'email' },
      { text: 'Dt. Cadastro', value: 'createdAt' },
    ]

    const resolveStatus = status => {
      const statusMap = {
        1: { label: 'Ativo', color: 'success' },
        0: { label: 'Inativo', color: 'error' },
      }

      return statusMap[status] || { label: 'Não definido', color: 'grey' }
    }

    return {
      dialogFilter,
      filterName,
      dialogCreateList,
      isEditMode,
      editingListId,
      createListForm,
      leads,
      dialogLead,
      editingLeadId,
      leadForm,
      headers,
      headersWithFilter,
      leadsHeaders,
      resolveStatus,

      // icons
      icons: {
        mdiCalendar,
        mdiClock,
        mdiEye,
        mdiFilterMenu,
        mdiFileEdit,
        mdiClose,
        mdiMagnify,
        mdiTablePlus,
        mdiDelete,
      },
    }
  },

  computed: {
    ...mapState('serviceListAutomation', {
      lists: 'rows',
    }),
  },

  async created() {
    await this.fetchLists()
  },

  methods: {
    ...mapActions('serviceListAutomation', [
      'find',
      'create',
      'update',
      'remove',
      'findLeadsByListId',
      'updateLead',
      'removeLead',
    ]),

    async fetchLists(params = {}) {
      // Por padrão, mostrar apenas listas ativas (status = 1)
      const defaultParams = {
        status: Number(1), // Garantir que seja número
        ...params,
      }
      // Se params.status foi passado, usar o valor passado (pode ser 0 para inativos)
      if (params.status !== undefined) {
        defaultParams.status = Number(params.status)
      }
      await this.find(defaultParams)
    },

    async filterLists(params = {}) {
      const filterParams = {
        name: this.filterName || null,
        status: params.status !== undefined ? Number(params.status) : Number(1), // Por padrão, mostrar apenas ativos
        ...params,
      }
      await this.fetchLists(filterParams)
    },

    clearFilter() {
      this.filterName = null
      this.filterLists()
    },

    openFormToCreate() {
      this.isEditMode = false
      this.editingListId = null
      this.dialogLead = false
      this.editingLeadId = null
      this.leadForm.nome = null
      this.leadForm.telefone = null
      this.leadForm.email = null
      this.leadForm.variablesJson = '{}'
      this.createListForm = {
        name: null,
        tags: [],
        isDynamic: false,
      }
      this.leads = []
      this.dialogCreateList = true
    },

    closeCreateListDialog() {
      this.dialogCreateList = false
      this.isEditMode = false
      this.editingListId = null
      this.dialogLead = false
      this.editingLeadId = null
      this.leadForm.nome = null
      this.leadForm.telefone = null
      this.leadForm.email = null
      this.leadForm.variablesJson = '{}'
      this.createListForm = {
        name: null,
        tags: [],
        isDynamic: false,
      }
      this.leads = []
    },

    async submitCreateList() {
      try {
        const body = {
          name: this.createListForm.name,
          tags: this.createListForm.tags || [],
          isDynamic: !!this.createListForm.isDynamic,
        }

        if (this.isEditMode && this.editingListId) {
          // Modo edição
          const status = await this.update({ id: this.editingListId, body })

          if (typeof status === 'number' && status >= 200 && status < 300) {
            this.$notify?.('Lista atualizada com sucesso', 'success')
          }
        } else {
          // Modo criação
          const status = await this.create(body)

          if (typeof status === 'number' && status >= 200 && status < 300) {
            this.$notify?.('Lista criada com sucesso', 'success')
          }
        }

        await this.fetchLists()
        this.closeCreateListDialog()
      } catch (err) {
        this.$notify?.(
          this.isEditMode ? 'Erro ao atualizar lista' : 'Erro ao criar lista',
          'error',
        )
      }
    },

    async openFormToEdit(item) {
      this.isEditMode = true
      this.editingListId = item.id
      this.createListForm = {
        name: item.name || null,
        tags: item.tags || [],
        isDynamic: !!item.isDynamic,
      }
      this.dialogCreateList = true
      
      // Carregar leads da lista
      try {
        const leadsData = await this.findLeadsByListId(item.id)
        this.leads = leadsData || []
      } catch (err) {
        console.error('Erro ao carregar leads:', err)
        this.leads = []
      }
    },

    openListDetail(item) {
      // TODO: Implementar abertura do detalhe da lista
      console.log('Abrir detalhe da lista', item)
    },

    openLeadForm(item) {
      this.editingLeadId = item.id
      this.leadForm.nome = item.name || null
      this.leadForm.telefone = item.phone || null
      this.leadForm.email = item.email || null
      this.leadForm.variablesJson =
        item.variables && typeof item.variables === 'object'
          ? JSON.stringify(item.variables, null, 2)
          : '{}'
      this.dialogLead = true
    },

    closeLeadDialog() {
      this.dialogLead = false
      this.editingLeadId = null
      this.leadForm.nome = null
      this.leadForm.telefone = null
      this.leadForm.email = null
      this.leadForm.variablesJson = '{}'
    },

    async submitLeadUpdate() {
      if (!this.editingLeadId) return

      let variablesObj = {}
      try {
        variablesObj = this.leadForm.variablesJson
          ? JSON.parse(this.leadForm.variablesJson)
          : {}
        if (
          !variablesObj ||
          typeof variablesObj !== 'object' ||
          Array.isArray(variablesObj)
        ) {
          throw new Error('Variáveis inválidas')
        }
      } catch (e) {
        this.$notify?.('Variáveis (JSON) inválidas', 'error')
        return
      }

      const body = {
        nome: this.leadForm.nome,
        telefone: this.leadForm.telefone,
        email: this.leadForm.email || null,
        variables: variablesObj || {},
      }

      try {
        const status = await this.updateLead({
          leadId: this.editingLeadId,
          body,
        })

        if (typeof status === 'number' && status >= 200 && status < 300) {
          this.$notify?.('Lead atualizado com sucesso', 'success')
          if (this.editingListId) {
            this.leads = await this.findLeadsByListId(this.editingListId)
          }
          this.closeLeadDialog()
        } else {
          this.$notify?.('Erro ao atualizar lead', 'error')
        }
      } catch (err) {
        this.$notify?.('Erro ao atualizar lead', 'error')
      }
    },

    confirmDeleteLead(item) {
      if (confirm(`Deseja realmente excluir o lead "${item.name}"?`)) {
        this.deleteLead(item)
      }
    },

    async deleteLead(item) {
      try {
        const status = await this.removeLead(item.id)

        if (typeof status === 'number' && status >= 200 && status < 300) {
          this.$notify?.('Lead excluído com sucesso', 'success')
          if (this.editingListId) {
            this.leads = await this.findLeadsByListId(this.editingListId)
          }
        } else {
          this.$notify?.('Erro ao excluir lead', 'error')
        }
      } catch (err) {
        this.$notify?.('Erro ao excluir lead', 'error')
      }
    },

    confirmDelete(item) {
      if (confirm(`Deseja realmente excluir a lista "${item.name}"?`)) {
        this.deleteList(item)
      }
    },

    async deleteList(item) {
      try {
        const body = {
          status: Number(0), // Inativo - garantir que seja número
        }

        const status = await this.update({ id: item.id, body })

        if (typeof status === 'number' && status >= 200 && status < 300) {
          this.$notify?.('Lista excluída com sucesso', 'success')
          await this.fetchLists()
        }
      } catch (err) {
        this.$notify?.('Erro ao excluir lista', 'error')
      }
    },
  },
}
</script>
